// extracted by mini-css-extract-plugin
export default {"faqPage":"FAQPage_faqPage__ea9z0","container":"FAQPage_container__Fx7nS","faqHeader":"FAQPage_faqHeader__fEeGx","faqTitle":"FAQPage_faqTitle__Iq6Br"};